export enum UserGroupDirectoryPermission {
  None = 0,
  Read = 1,
  Write = 2,
  Deny = 3,
  ReadOnly = 4,
  NoAccess = 5,
}

export interface OrganizationDirectoryDto {
  id: number;
  parentId: number | null;
  name: string;
  isDeleted: boolean;
}

export interface UserGroupDirectoryPermissionDto {
  userGroupId: string;
  directoryId: number;
  permission: UserGroupDirectoryPermission;
}

export interface UserGroupDirectoryPermissionsChangeDto {
  userGroupIds: string[];
  directoryIds: number[];
  permission: UserGroupDirectoryPermission;
}
